module.exports = __webpack_public_path__ + "assets1733911544048/img/avator.bd584bb1.png";